import update from "react/lib/update";
import * as actionConsts from "./actions";

export const initState = {
  departments: [],
  isLoading: false,
  showFavorites: true,
};

export default (state = initState, action) => {
  switch (action.type) {
    case actionConsts.GET_DEPARTMENTS_REQUEST:
      return update(state, {
        isLoading: {
          $set: true,
        },
      });
    case actionConsts.GET_DEPARTMENTS_SUCCESS:
      return update(state, {
        departments: {
          $set: action.departments,
        },
        isLoading: {
          $set: false,
        },
      });
    case actionConsts.GET_DEPARTMENTS_FAILURE:
      return update(state, {
        isLoading: {
          $set: false,
        },
      });
    case actionConsts.CREATE_DEPARTMENT_REQUEST:
      return update(state, {
        departments: {
          $splice: [[0, 0, action.department]],
        },
      });
    case actionConsts.CREATE_DEPARTMENT_SUCCESS:
      return update(state, {
        departments: {
          0: {
            id: {
              $set: action.departmentId,
            },
            activities: {
              $set: action.acks,
            },
          },
        },
      });
    case actionConsts.CREATE_DEPARTMENT_FAILURE:
      return update(state, {
        departments: {
          $splice: [[0, 1]],
        },
      });
    case actionConsts.EDIT_DEPARTMENT_REQUEST:
    case actionConsts.EDIT_DEPARTMENT_FAILURE:
      return update(state, {
        departments: {
          [action.departmentIndex]: {
            name: {
              $set: action.departmentName,
            },
          },
        },
      });
    case actionConsts.TOGGLE_FAVORITE_DEPARTMENT:
      return update(state, {
        departments: {
          [action.departmentIndex]: {
            favorite: {
              $set: action.favorite,
            },
          },
        },
      });
    case actionConsts.SET_SHOW_FAVORITES:
      return update(state, {
        showFavorites: {
          $set: action.showFavorites,
        },
      });
    case actionConsts.REMOVE_ACK:
      return update(state, {
        departments: {
          [action.departmentIndex]: {
            activities: {
              $splice: [[action.ackIndex, 1]],
            },
          },
        },
      });
    case actionConsts.ADD_ACK:
      return update(state, {
        departments: {
          [action.departmentIndex]: {
            activities: {
              $splice: [[0, 0, action.ackName]],
            },
          },
        },
      });

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/App/Department/reducer.js